import {useEffect, useState} from "react";
import {motion} from "framer-motion";
import {IRestaurateur} from "../../utils/interfaces/IRestaurateur";
import {IRestaurant} from "../../utils/interfaces/IRestaurant";
import RestaurantRow from "./RestaurantRow";


interface RestaurantsListProps {
    obj: IRestaurateur,
}

function RestaurantsList({obj: initialObj}: RestaurantsListProps) {
    const [obj, setObj] = useState<IRestaurateur>(initialObj)

    const mapped_objs = obj?.restaurants.map((obj: IRestaurant, index) => (
        <motion.div
            key={obj.name}
            initial={{x: '150%'}}
            animate={{x: '0%'}}
            transition={{duration: 0.2, delay: index * 0.03}}
        >
            <RestaurantRow obj={obj}/>
        </motion.div>

    ));

    useEffect(() => {
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj])

    return (
        <>
            {mapped_objs}
        </>
    )
}

export default RestaurantsList;